"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _reactIntl = require("react-intl");
var _ui = require("@unite-us/ui");
var _HoursOfOperationToday = _interopRequireDefault(require("../HoursOfOperationToday"));
var _constants = require("../HoursOfOperationToday/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var HoursOfOperationV2 = function HoursOfOperationV2(props) {
  var className = props.className,
    showHoursIcon = props.showHoursIcon,
    hideLabel = props.hideLabel,
    hours = props.hours,
    hoursLabel = props.hoursLabel,
    showAll = props.showAll,
    showToggle = props.showToggle,
    shouldStartWeekToday = props.shouldStartWeekToday,
    color = props.color,
    iconColor = props.iconColor,
    intlProvider = props.intlProvider,
    abbreviateDays = props.abbreviateDays,
    closedText = props.closedText,
    startTimeKey = props.startTimeKey,
    endTimeKey = props.endTimeKey;
  var hoursLabelDisplay = !(0, _lodash.isEmpty)(intlProvider) ? /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "FFkm1d",
    description: "provider-hours-text",
    defaultMessage: "Hours"
  }, function (txt) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "ui-hours-of-operation-v2__title--label mr-3 inline"
    }, "".concat(txt, ":"));
  }) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "ui-hours-of-operation-v2__title--label mr-3 inline"
  }, hoursLabel);
  if (!(0, _lodash.isEmpty)(hours)) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "ui-hours-of-operation-v2 flex items-start flex-row ".concat(className),
      style: {
        color: color
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "ui-hours-of-operation-v2__title inline-flex items-center flex-none"
    }, showHoursIcon && /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
      className: "ui-hours-of-operation-v2__title--icon mr-half inline",
      color: color || iconColor || '#4571BA',
      icon: "IconClock"
    }), !hideLabel && hoursLabelDisplay), /*#__PURE__*/_react["default"].createElement(_HoursOfOperationToday["default"], {
      hours: hours,
      showAll: showAll,
      showToggle: showToggle,
      abbreviateDays: abbreviateDays,
      closedText: closedText,
      endTimeKey: endTimeKey,
      startTimeKey: startTimeKey,
      shouldStartWeekToday: shouldStartWeekToday
    }));
  }
  return null;
};
HoursOfOperationV2.propTypes = {
  className: _propTypes["default"].string,
  /** display hours Icon next to label */
  showHoursIcon: _propTypes["default"].bool,
  /** hide 'Hours Today' label */
  hideLabel: _propTypes["default"].bool,
  /** hours of operation values to display */
  hours: _propTypes["default"].object,
  /** custom label for hours */
  hoursLabel: _propTypes["default"].string,
  /** should display all days or only the first one */
  showAll: _propTypes["default"].bool,
  /** should display a separate caret to individually toggle hours */
  showToggle: _propTypes["default"].bool,
  /** should start the days of the week on current day */
  shouldStartWeekToday: _propTypes["default"].bool,
  /** color of text */
  color: _propTypes["default"].string,
  /** custom color for icon */
  iconColor: _propTypes["default"].string,
  /** is international provider */
  intlProvider: _propTypes["default"].object,
  /** show abbreviated day labels instead of full day (i.e. `Mon` vs `Monday`) */
  abbreviateDays: _propTypes["default"].bool,
  /** text to display when given day has no hours associated */
  closedText: _propTypes["default"].string,
  /** key for start time in hours object (`{ monday: { opens: '09:00', closes: '17:00' } }`) */
  startTimeKey: _propTypes["default"].string,
  /** key for end time in hours object (`{ monday: { opens: '09:00', closes: '17:00' } }`) */
  endTimeKey: _propTypes["default"].string
};
HoursOfOperationV2.defaultProps = {
  className: '',
  showHoursIcon: false,
  hideLabel: false,
  hours: {},
  hoursLabel: 'Hours Today',
  showAll: false,
  showToggle: false,
  shouldStartWeekToday: true,
  color: null,
  iconColor: null,
  intlProvider: {},
  abbreviateDays: true,
  closedText: _constants.CLOSED_DAY,
  startTimeKey: 'opens',
  endTimeKey: 'closes'
};
var _default = exports["default"] = HoursOfOperationV2;